import * as z from 'zod';
import { extractionStatusSchema, extractionErrorTypeSchema } from '../../../enums.mjs';
import '../../../types/actor/actor.mjs';
import '../../../types/address/address.mjs';
import '../../../types/credit-report/company-credit-report.mjs';
import '../../../types/credit-report/individual-credit-report.mjs';
import '../../../types/currency/currency.mjs';
import '../../../types/entityRelation/entity-relation.mjs';
import '../../../types/financial-formula/adjustable-value.mjs';
import '../../../types/financial-formula/adjustable-values-update.mjs';
import '../../../types/financial-formula/adjustment.mjs';
import '../../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../../types/is-encrypted.mjs';
import '../../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, fileId, applicationExtractionId } from '../../../types/opaque.mjs';
import '../../../types/surety/account/bonding-line.mjs';
import '../../../types/surety/account/surety-account.types.mjs';
import { ApplicationExtractionOutput } from '../../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../../types/surety/bond/surety-bond.types.mjs';
import '../../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../../types/surety/contract/contract-extraction-output.mjs';
import '../../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../../types/surety/quote/surety-quote.types.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../../types/user/user.types.mjs';
import '../../../types/utils.mjs';

const applicationExtractionResponseSchema = z.object({
    id: applicationExtractionId,
    fileId: fileId,
    status: extractionStatusSchema,
    output: ApplicationExtractionOutput.optional(),
    errorType: extractionErrorTypeSchema.optional(),
    errorMessage: z.string().optional(),
    createdAt: isoDateTimeSchema,
});
var Create;
(function (Create) {
    (function (Request) {
        Request.schema = z.object({
            fileId: fileId,
        });
    })(Create.Request || (Create.Request = {}));
    (function (Response) {
        Response.schema = applicationExtractionResponseSchema;
    })(Create.Response || (Create.Response = {}));
})(Create || (Create = {}));
var Get;
(function (Get) {
    (function (Response) {
        Response.schema = applicationExtractionResponseSchema;
    })(Get.Response || (Get.Response = {}));
})(Get || (Get = {}));
var List;
(function (List) {
    (function (Response) {
        Response.schema = z.array(applicationExtractionResponseSchema);
    })(List.Response || (List.Response = {}));
})(List || (List = {}));

export { Create, Get, List, applicationExtractionResponseSchema };
